import { useContext } from 'react';
import ConfigContext, { ContextType } from 'contexts/ConfigContext';

export default function useConfig(): ContextType {
  return useContext(ConfigContext);
}
